import { createFileRoute, redirect } from "@tanstack/react-router";

export const Route = createFileRoute("/en/kalender-hijriah/$hyear/$hmonth/")({
  beforeLoad: ({ params }) => {
    throw redirect({ to: `/en/hijri-calendar/${params.hyear}/${params.hmonth}/` } as any);
  },
  component: () => null,
});
